
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={},$1={payload: false};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/preview"){r.unshift({data:$0});}else if(p==="/pronto.svg"){r.unshift({data:$0});}let s=p.split("/"),l=s.length;r.unshift({data:$1,params:{"_":s.slice(1).join('/'),}});return r;}})()
      export default (path) => defu({}, ...matcher('', path).map(r => r.data).reverse())
      